<template>
	<div>
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.change_password[$store.state.lang.language]}}</h4>
				</div>
			</div>
			<div class="md-layout-item md-small-size-10 md-medium-size-15 md-size-20"></div>
			<div class="md-layout-item md-small-size-80 md-medium-size-70 md-size-60">
				<div class="form__tabs__wrap" v-if="loaded">
					<form @submit.prevent="changePassword()">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input type="password" v-model="user.old_password" :placeholder="$store.state.lang.text.old_password[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input v-model="user.new_password" type="password" :placeholder="$store.state.lang.text.new_password[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input v-model="user.confirm_password" type="password" :placeholder="$store.state.lang.text.confirm_new_password[$store.state.lang.language]"></div>
							</div>
						</div>
						<div class="create__btn" style="margin-top: 18px"><a class="cmn--btn" @click="changePassword()"><span>{{$store.state.lang.text.change[$store.state.lang.language]}}</span></a></div>
					</form>
			   </div>
			</div>
			<div class="md-layout-item md-medium-size-15 md-size-20"></div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {

		},
		methods: {
			changePassword() {
				if(this.user.old_password.length > 5 && this.user.new_password.length > 5 && this.user.confirm_password == this.user.new_password) {
					this.$http.post(this.config.api + "/user/authed/user/change_password",{
						old_password: this.user.old_password,
						new_password: this.user.new_password,
						confirm_password: this.user.confirm_password
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify(this.$store.state.lang.text.change_password_success[this.$store.state.lang.language]);
							this.user.old_password = "";
							this.user.new_password = "";
							this.user.confirm_password = "";
							this.$router.push("/account");
						}
					})
				} else {
					this.$notification.notify(this.$store.state.lang.text.pleaseFill[this.$store.state.lang.language]);
				}
			},

		},
		computed: {
		},
		data() {
			return {
				loaded: true,
				user: {
					old_password:"",
					new_password: "",
					confirm_password: ""
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Account/ChangePassword.vue